import { Box, keyframes } from '@mui/material';

// keyframes for bounce animation
const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

export default function DotLoader() {
  return (
    <Box display="flex" alignItems="center" padding={1}>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          component="span"
          sx={{
            width: 6,
            height: 6,
            mx: 0.5,
            borderRadius: '50%',
            bgcolor: 'text.primary',
            display: 'inline-block',
            animation: `${bounce} 1.4s infinite ease-in-out`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
}
